import React from "react";
import AppView from "./AppView";

const App: React.FC = () => {
  return <AppView />;
};

export default App;
